import { useHomeBanner, usePostDetailData } from '@/src/api/getData';
import { useParams } from 'react-router-dom';
import Banner from '@/components/banner';
import DateTime from '@/components/dateTime';

const LatestUpdateDetailsView: any = ({ language = '' }) => {
    const { id } = useParams();
    const { data: banner } = useHomeBanner(language);
    const { data: postData } = usePostDetailData(language, Number(id));
    let postDetailData = postData?.data?.[0] || {};
    let componentsType = postDetailData?.Media?.[0]?.__component || '';
    let mediatype = postDetailData?.Media?.[0]?.Media?.ext;
    const locateSrc = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') ? '/backend/public' : '';
    return (
        <main className='theme-latest-update' id="start">
            <Banner banner={banner} category="Latest Updates" />
                {postData && (
                    <section className="news-details container">
                        <h2>{postDetailData?.Title}</h2>
                        <div className="news-info">
                            <div className="news-date">
                                <DateTime date={postDetailData?.Date} language={language} />
                            </div>
                            <div className="catagory-label">
                                {language=="en"? postDetailData?.Category?.Title || '' : postDetailData?.Category?.Zh_title || ''}
                            </div>
                        </div>
                        <div className="news-content" dangerouslySetInnerHTML={{ __html: postDetailData?.Content?.[0]?.Editor || postDetailData?.ShotContent }} />
                        <div className="news-image">
                            {componentsType === "components.title-media" && (
                                (mediatype === ".mp4" ? (
                                    <video controls>
                                        <source src={postDetailData?.Media?.[0]?.Media?.url || ''} type="video/mp4" />
                                    </video>
                                ) : (
                                    <img src={`${locateSrc}${postDetailData?.Media?.[0]?.Media?.url || ''}`} alt={postDetailData?.Title || ''} />
                                ))
                            )}
                            {componentsType === "components.video-code" && (
                                <iframe id="ytplayer"
                                    src={`https://www.youtube.com/embed/${postDetailData?.Media?.[0]?.Youtube}?autoplay=0`}
                                    frameBorder="0"></iframe>
                            )}
                        </div>
                    </section>
                )}
        </main>
    );
}

export default LatestUpdateDetailsView;